import { Box, useTheme } from "@mui/material";
import logoIcon from "/images/kmar-small.svg"; // NOSONAR — Vite public folder convention

export const PrintHeader = () => {
  const theme = useTheme();

  return (
    <Box
      className="print-header"
      sx={{
        display: "none",
        mb: 2,
        borderBottom: `1px solid ${theme.palette.divider}`,
        pb: 2,
      }}
    >
      {/* <img src={logoIcon} width={40} height={70} alt="Logo" /> */}
    </Box>
  );
};
